<template>
    <svg width="30px" height="30px" viewBox="0 0 32 32" id="OBJECT" xmlns="http://www.w3.org/2000/svg" fill="#016B00" stroke="#016B00">

        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
        
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
        
        <g id="SVGRepo_iconCarrier">
        
        <defs>
        
   
        
        </defs>
        
        <title/>
        
        <path class="cls-1" d="M9.26,17.35A1,1,0,0,0,8.5,17h-5a1,1,0,0,0-1,1V30a1,1,0,0,0,1,1H4.81a3,3,0,0,0,3-2.51L9.49,18.16A1,1,0,0,0,9.26,17.35Z"/>
        
        <path class="cls-1" d="M22.58,3.19a1,1,0,0,0-.9-.14L9.84,7H4a3,3,0,0,0-3,3v8a1,1,0,0,0,1,1H9.84L21.68,23A1.19,1.19,0,0,0,22,23a.94.94,0,0,0,.58-.19A1,1,0,0,0,23,22V4A1,1,0,0,0,22.58,3.19Z"/>
        
        <path d="M9.84,19V7H4a3,3,0,0,0-3,3v8a1,1,0,0,0,1,1Z"/>
        
        <path class="cls-1" d="M27.76,7.76l-1.31-.65A1,1,0,0,0,25,8V18a1,1,0,0,0,.47.85A1,1,0,0,0,26,19a1,1,0,0,0,.45-.11l1.31-.65a5.86,5.86,0,0,0,0-10.48Z"/>
        
        <path d="M24,1H22a1,1,0,0,0-1,1V24a1,1,0,0,0,1,1h2a3,3,0,0,0,3-3V4A3,3,0,0,0,24,1Z"/>
        
        </g>
        
        </svg>
</template>
<style>.cls-1{fill:#CCAF12;}</style>